import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Character from "./pages/Character";
import Vehicles from "./pages/Vehicles";
import Properties from "./pages/Properties";
import Inventory from "./pages/Inventory";
import Jobs from "./pages/Jobs";
import Transactions from "./pages/Transactions";
import Record from "./pages/Record";
import Stats from "./pages/Stats";
import Admin from "./pages/Admin";

function Guard({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AdminGuard({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;
  if (user.role !== "admin" && user.role !== "owner") return <Navigate to="/dashboard" replace />;
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : <Login />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route element={<Guard><Layout /></Guard>}>
              <Route path="/dashboard" element={<Character />} />
              <Route path="/vehicles" element={<Vehicles />} />
              <Route path="/properties" element={<Properties />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/record" element={<Record />} />
              <Route path="/stats" element={<Stats />} />
              <Route path="/admin" element={<AdminGuard><Admin /></AdminGuard>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
